const searchFormValue = {
    search: null
};

const operatorOptions = [
    { text: '선택해주세요.', value: null, disabled: true },
    { text: '==(같음)', value: '==' },
    { text: '!=(다름)', value: '!=' },
    { text: '<(작음)', value: '<' },
    { text: '≤(작거나 같음)', value: '<=' },
    { text: '>(큼)', value: '>' },
    { text: '≥(크거나 같음)', value: '>=' },
    { text: 'IN(포함)', value: 'IN' },
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'name',
        label: '조건명',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'key',
        label: '조건 키',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'operator',
        label: '연산자',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

export { searchFormValue, columns, operatorOptions};
